// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_wss","cls2":"SingularMentionCitationModal-cls2_Nc7 SingularMentionCitationModal-cls1_wss"};